/**
 * @fileoverview gRPC-Web generated client stub for witbooking.backoffice.condition.v1
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!



const grpc = {};
grpc.web = require('grpc-web');

const proto = {};
proto.witbooking = {};
proto.witbooking.backoffice = {};
proto.witbooking.backoffice.condition = {};
proto.witbooking.backoffice.condition.v1 = require('./condition_api_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.witbooking.backoffice.condition.v1.ConditionAPIClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.witbooking.backoffice.condition.v1.ConditionAPIPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.condition.v1.GetConditionsRequest,
 *   !proto.witbooking.backoffice.condition.v1.GetConditionsResponse>}
 */
const methodDescriptor_ConditionAPI_GetConditions = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.condition.v1.ConditionAPI/GetConditions',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.condition.v1.GetConditionsRequest,
  proto.witbooking.backoffice.condition.v1.GetConditionsResponse,
  /**
   * @param {!proto.witbooking.backoffice.condition.v1.GetConditionsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.condition.v1.GetConditionsResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.condition.v1.GetConditionsRequest,
 *   !proto.witbooking.backoffice.condition.v1.GetConditionsResponse>}
 */
const methodInfo_ConditionAPI_GetConditions = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.condition.v1.GetConditionsResponse,
  /**
   * @param {!proto.witbooking.backoffice.condition.v1.GetConditionsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.condition.v1.GetConditionsResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.condition.v1.GetConditionsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.condition.v1.GetConditionsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.condition.v1.GetConditionsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.condition.v1.ConditionAPIClient.prototype.getConditions =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.condition.v1.ConditionAPI/GetConditions',
      request,
      metadata || {},
      methodDescriptor_ConditionAPI_GetConditions,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.condition.v1.GetConditionsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.condition.v1.GetConditionsResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.condition.v1.ConditionAPIPromiseClient.prototype.getConditions =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.condition.v1.ConditionAPI/GetConditions',
      request,
      metadata || {},
      methodDescriptor_ConditionAPI_GetConditions);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.condition.v1.GetLinkedConditionsRequest,
 *   !proto.witbooking.backoffice.condition.v1.GetLinkedConditionsResponse>}
 */
const methodDescriptor_ConditionAPI_GetLinkedConditions = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.condition.v1.ConditionAPI/GetLinkedConditions',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.condition.v1.GetLinkedConditionsRequest,
  proto.witbooking.backoffice.condition.v1.GetLinkedConditionsResponse,
  /**
   * @param {!proto.witbooking.backoffice.condition.v1.GetLinkedConditionsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.condition.v1.GetLinkedConditionsResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.condition.v1.GetLinkedConditionsRequest,
 *   !proto.witbooking.backoffice.condition.v1.GetLinkedConditionsResponse>}
 */
const methodInfo_ConditionAPI_GetLinkedConditions = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.condition.v1.GetLinkedConditionsResponse,
  /**
   * @param {!proto.witbooking.backoffice.condition.v1.GetLinkedConditionsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.condition.v1.GetLinkedConditionsResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.condition.v1.GetLinkedConditionsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.condition.v1.GetLinkedConditionsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.condition.v1.GetLinkedConditionsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.condition.v1.ConditionAPIClient.prototype.getLinkedConditions =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.condition.v1.ConditionAPI/GetLinkedConditions',
      request,
      metadata || {},
      methodDescriptor_ConditionAPI_GetLinkedConditions,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.condition.v1.GetLinkedConditionsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.condition.v1.GetLinkedConditionsResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.condition.v1.ConditionAPIPromiseClient.prototype.getLinkedConditions =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.condition.v1.ConditionAPI/GetLinkedConditions',
      request,
      metadata || {},
      methodDescriptor_ConditionAPI_GetLinkedConditions);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.condition.v1.CreateLegacyConditionRequest,
 *   !proto.witbooking.backoffice.condition.v1.CreateLegacyConditionResponse>}
 */
const methodDescriptor_ConditionAPI_CreateLegacyCondition = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.condition.v1.ConditionAPI/CreateLegacyCondition',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.condition.v1.CreateLegacyConditionRequest,
  proto.witbooking.backoffice.condition.v1.CreateLegacyConditionResponse,
  /**
   * @param {!proto.witbooking.backoffice.condition.v1.CreateLegacyConditionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.condition.v1.CreateLegacyConditionResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.condition.v1.CreateLegacyConditionRequest,
 *   !proto.witbooking.backoffice.condition.v1.CreateLegacyConditionResponse>}
 */
const methodInfo_ConditionAPI_CreateLegacyCondition = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.condition.v1.CreateLegacyConditionResponse,
  /**
   * @param {!proto.witbooking.backoffice.condition.v1.CreateLegacyConditionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.condition.v1.CreateLegacyConditionResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.condition.v1.CreateLegacyConditionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.condition.v1.CreateLegacyConditionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.condition.v1.CreateLegacyConditionResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.condition.v1.ConditionAPIClient.prototype.createLegacyCondition =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.condition.v1.ConditionAPI/CreateLegacyCondition',
      request,
      metadata || {},
      methodDescriptor_ConditionAPI_CreateLegacyCondition,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.condition.v1.CreateLegacyConditionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.condition.v1.CreateLegacyConditionResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.condition.v1.ConditionAPIPromiseClient.prototype.createLegacyCondition =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.condition.v1.ConditionAPI/CreateLegacyCondition',
      request,
      metadata || {},
      methodDescriptor_ConditionAPI_CreateLegacyCondition);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.condition.v1.UpdateLegacyConditionRequest,
 *   !proto.witbooking.backoffice.condition.v1.UpdateLegacyConditionResponse>}
 */
const methodDescriptor_ConditionAPI_UpdateLegacyCondition = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.condition.v1.ConditionAPI/UpdateLegacyCondition',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.condition.v1.UpdateLegacyConditionRequest,
  proto.witbooking.backoffice.condition.v1.UpdateLegacyConditionResponse,
  /**
   * @param {!proto.witbooking.backoffice.condition.v1.UpdateLegacyConditionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.condition.v1.UpdateLegacyConditionResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.condition.v1.UpdateLegacyConditionRequest,
 *   !proto.witbooking.backoffice.condition.v1.UpdateLegacyConditionResponse>}
 */
const methodInfo_ConditionAPI_UpdateLegacyCondition = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.condition.v1.UpdateLegacyConditionResponse,
  /**
   * @param {!proto.witbooking.backoffice.condition.v1.UpdateLegacyConditionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.condition.v1.UpdateLegacyConditionResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.condition.v1.UpdateLegacyConditionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.condition.v1.UpdateLegacyConditionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.condition.v1.UpdateLegacyConditionResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.condition.v1.ConditionAPIClient.prototype.updateLegacyCondition =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.condition.v1.ConditionAPI/UpdateLegacyCondition',
      request,
      metadata || {},
      methodDescriptor_ConditionAPI_UpdateLegacyCondition,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.condition.v1.UpdateLegacyConditionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.condition.v1.UpdateLegacyConditionResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.condition.v1.ConditionAPIPromiseClient.prototype.updateLegacyCondition =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.condition.v1.ConditionAPI/UpdateLegacyCondition',
      request,
      metadata || {},
      methodDescriptor_ConditionAPI_UpdateLegacyCondition);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.condition.v1.DeleteLegacyConditionRequest,
 *   !proto.witbooking.backoffice.condition.v1.DeleteLegacyPromotionResponse>}
 */
const methodDescriptor_ConditionAPI_DeleteLegacyCondition = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.condition.v1.ConditionAPI/DeleteLegacyCondition',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.condition.v1.DeleteLegacyConditionRequest,
  proto.witbooking.backoffice.condition.v1.DeleteLegacyPromotionResponse,
  /**
   * @param {!proto.witbooking.backoffice.condition.v1.DeleteLegacyConditionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.condition.v1.DeleteLegacyPromotionResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.condition.v1.DeleteLegacyConditionRequest,
 *   !proto.witbooking.backoffice.condition.v1.DeleteLegacyPromotionResponse>}
 */
const methodInfo_ConditionAPI_DeleteLegacyCondition = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.condition.v1.DeleteLegacyPromotionResponse,
  /**
   * @param {!proto.witbooking.backoffice.condition.v1.DeleteLegacyConditionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.condition.v1.DeleteLegacyPromotionResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.condition.v1.DeleteLegacyConditionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.condition.v1.DeleteLegacyPromotionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.condition.v1.DeleteLegacyPromotionResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.condition.v1.ConditionAPIClient.prototype.deleteLegacyCondition =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.condition.v1.ConditionAPI/DeleteLegacyCondition',
      request,
      metadata || {},
      methodDescriptor_ConditionAPI_DeleteLegacyCondition,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.condition.v1.DeleteLegacyConditionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.condition.v1.DeleteLegacyPromotionResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.condition.v1.ConditionAPIPromiseClient.prototype.deleteLegacyCondition =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.condition.v1.ConditionAPI/DeleteLegacyCondition',
      request,
      metadata || {},
      methodDescriptor_ConditionAPI_DeleteLegacyCondition);
};


module.exports = proto.witbooking.backoffice.condition.v1;

